export function EigenEinStarrHoch(Lineargewicht, Länge, E, Iy) {
  const erg =
    (((((Lineargewicht / 1000) * 9.81 * Länge) / 1000 / 8) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertEinStarrHoch(Verteilt, Länge, E, Iy) {
  const erg = ((((Verteilt * Länge) / 1000 / 8) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktEinStarrHoch(Punkt, Länge, E, Iy) {
  const erg = (Punkt / 3) * ((Länge ** 3 / E / Iy) * 0.0001);
  return Math.round(erg * 100) / 100;
}

export function EinStarrHochZwang(Punkt, Länge, Verteilt, Lineargewicht, Iy, X) {
  const erg =
    ((((Punkt * Länge) / 1000 +
      (((Lineargewicht / 1000) * 9.81 + Verteilt) * (Länge / 1000) ** 2) / 2) /
      Iy) *
      X) /
    20;
  return Math.round(erg * 100) / 100;
}

export function EigenEinStarrQuer(Lineargewicht, Länge, E, Ix) {
  const erg =
    (((((Lineargewicht / 1000) * 9.81 * Länge) / 1000 / 8) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertEinStarrQuer(Verteilt, Länge, E, Ix) {
  const erg = ((((Verteilt * Länge) / 1000 / 8) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktEinStarrQuer(Punkt, Länge, E, Ix) {
  const erg = (Punkt / 3) * ((Länge ** 3 / E / Ix) * 0.0001);
  return Math.round(erg * 100) / 100;
}

export function EinStarrQuerZwang(Punkt, Länge, Verteilt, Lineargewicht, Ix, Y) {
  const erg =
    ((((Punkt * Länge) / 1000 +
      (((Lineargewicht / 1000) * 9.81 + Verteilt) * (Länge / 1000) ** 2) / 2) /
      Ix) *
      Y) /
    20;
  return Math.round(erg * 100) / 100;
}

export function EigenAufHoch(Lineargewicht, Länge, E, Iy) {
  const erg =
    (((((((Lineargewicht / 1000) * 9.81 * Länge) / 1000) * 5) / 384) * Länge ** 3) /
      E /
      Iy) *
    0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertAufHoch(Verteilt, Länge, E, Iy) {
  const erg = ((((((Verteilt * Länge) / 1000) * 5) / 384) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktAufHoch(Punkt, Länge, E, Iy) {
  const erg = (((Punkt / 48) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function AufHochZwang(Punkt, Länge, Verteilt, Lineargewicht, Iy, X) {
  const erg =
    ((((Punkt * Länge) / 1000 / 4 +
      ((Verteilt + (Lineargewicht / 1000) * 9.81) * (Länge / 1000) ** 2) / 8) /
      Iy) *
      X) /
    20;
  return Math.round(erg * 100) / 100;
}

export function EigenAufQuer(Lineargewicht, Länge, E, Ix) {
  const erg =
    (((((((Lineargewicht / 1000) * 9.81 * Länge) / 1000) * 5) / 384) * Länge ** 3) /
      E /
      Ix) *
    0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertAufQuer(Verteilt, Länge, E, Ix) {
  const erg = ((((((Verteilt * Länge) / 1000) * 5) / 384) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktAufQuer(Punkt, Länge, E, Ix) {
  const erg = (((Punkt / 48) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function AufQuerZwang(Punkt, Länge, Verteilt, Lineargewicht, Ix, Y) {
  const erg =
    ((((Punkt * Länge) / 1000 / 4 +
      ((Verteilt + (Lineargewicht / 1000) * 9.81) * (Länge / 1000) ** 2) / 8) /
      Ix) *
      Y) /
    20;
  return Math.round(erg * 100) / 100;
}

export function EigenZweiStarrHoch(Lineargewicht, Länge, E, Iy) {
  const erg =
    (((((Lineargewicht / 1000) * 9.81 * Länge) / 1000 / 384) * Länge ** 3) / E / Iy) *
    0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertZweiStarrHoch(Verteilt, Länge, E, Iy) {
  const erg = ((((Verteilt * Länge) / 1000 / 384) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktZweiStarrHoch(Punkt, Länge, E, Iy) {
  const erg = (((Punkt / 192) * Länge ** 3) / E / Iy) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function ZweiStarrHochZwang(Punkt, Verteilt, Lineargewicht, Länge, Iy, X) {
  const erg =
    ((((Punkt * Länge) / 1000 / 8 +
      ((Verteilt + (Lineargewicht / 1000) * 9.81) * (Länge / 1000) ** 2) / 12) /
      Iy) *
      X) /
    20;
  return Math.round(erg * 100) / 100;
}

export function EigenZweiStarrQuer(Lineargewicht, Länge, E, Ix) {
  const erg =
    (((((Lineargewicht / 1000) * 9.81 * Länge) / 1000 / 384) * Länge ** 3) / E / Ix) *
    0.0001;
  return Math.round(erg * 100) / 100;
}

export function VertZweiStarrQuer(Verteilt, Länge, E, Ix) {
  const erg = ((((Verteilt * Länge) / 1000 / 384) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function PunktZweiStarrQuer(Punkt, Länge, E, Ix) {
  const erg = (((Punkt / 192) * Länge ** 3) / E / Ix) * 0.0001;
  return Math.round(erg * 100) / 100;
}

export function ZweiStarrQuerZwang(Punkt, Verteilt, Lineargewicht, Länge, Ix, Y) {
  const erg =
    ((((Punkt * Länge) / 1000 / 8 +
      ((Verteilt + (Lineargewicht / 1000) * 9.81) * (Länge / 1000) ** 2) / 12) /
      Ix) *
      Y) /
    20;
  return Math.round(erg * 100) / 100;
}

export function SenkStarrHoch(Punkt, b, Länge, E, Iy) {
  const erg = (Punkt * b * Länge ** 2) / 2 / E / Iy / 10000;
  return Math.round(erg * 100) / 100;
}

export function SenkStarrHochZwang(b, Punkt, Iy, X) {
  const erg = (((b * Punkt) / 1000 / Iy) * X) / 20;
  return Math.round(erg * 100) / 100;
}

export function SenkStarrQuer(Punkt, b, Länge, E, Ix) {
  const erg = (Punkt * b * Länge ** 2) / 2 / E / Ix / 10000;
  return Math.round(erg * 100) / 100;
}

export function SenkStarrQuerZwang(b, Punkt, Ix, Y) {
  const erg = (((b * Punkt) / 1000 / Ix) * Y) / 20;
  return Math.round(erg * 100) / 100;
}

export function EinDreh(Mt, Länge, G, It) {
  const erg = (180 * Mt * Länge) / (Math.PI * G * It * 10);
  return Math.round(erg * 100) / 100;
}

export function EinDrehZwang(Mt, PESQ, Iy, X) {
  const erg = (((Mt * PESQ) / 1000 / Iy) * X) / 20;
  return Math.round(erg * 100) / 100;
}

export function ZweiDreh(Mt, Länge, G, It) {
  const erg = (180 * Mt * Länge) / (Math.PI * G * It * 40);
  return Math.round(erg * 100) / 100;
}

export function ZweiDrehZwang(Mt, PESQ, Ix, Y) {
  const erg = (((Mt * PESQ) / 1000 / Ix) * Y) / 20;
  return Math.round(erg * 100) / 100;
}

export function AufliegendVersetztePunktLastHochkant(Last, Länge, Distanz, E, Iy) {
  const f = (Last * Distanz ** 2 * (Länge - Distanz) ** 2) / 3 / E / Iy / Länge;
  const erg =
    ((f * (parseInt(Distanz, 10) + parseInt(Länge, 10))) / 3 / Distanz) *
    Math.sqrt((parseInt(Distanz, 10) + parseInt(Länge, 10)) / 3 / (Länge - Distanz)) *
    0.0001;
  return Math.round(erg * 100) / 100;
}

export function AufliegendVersetztePunktLastQuer(Last, Länge, Distanz, E, Ix) {
  const f = (Last * Distanz ** 2 * (Länge - Distanz) ** 2) / 3 / E / Ix / Länge;
  const erg =
    ((f * (parseInt(Distanz, 10) + parseInt(Länge, 10))) / 3 / Distanz) *
    Math.sqrt((parseInt(Distanz, 10) + parseInt(Länge, 10)) / 3 / (Länge - Distanz)) *
    0.0001;
  return Math.round(erg * 100) / 100;
}
